<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.type} input-${size}`"
    :data-type="context.type"
  >
    <div class="d-flex align-items-center gap-2 hour-minute-input">
      <FormulateInput
        v-model="hours"
        type="number"
        min="0"
        ignored
        :size="size"
        :disabled="context.attributes.disabled"
        class="flex-grow-1 mb-0"
        @blur="handleBlur"
      >
        <template #suffix>
          <div class="formulate-input-suffix">
            <span>{{ $t('global.time.hour') }}</span>
          </div>
        </template>
      </FormulateInput>

      <FormulateInput
        v-model="minutes"
        type="number"
        min="0"
        max="59"
        ignored
        :size="size"
        :disabled="context.attributes.disabled"
        class="flex-grow-1 mb-0"
        @blur="handleBlur"
      >
        <template #suffix>
          <div class="formulate-input-suffix">
            <span>{{ $t('global.time.minutes') }}</span>
          </div>
        </template>
      </FormulateInput>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'sm',
    },
  },
  data() {
    return {
      hours: 0,
      minutes: 0,
    }
  },
  watch: {
    'context.model': {
      handler(val) {
        this.updateLocalValues(val)
      },
      immediate: true,
    },
    hours() {
      this.updateModel()
    },
    minutes() {
      this.updateModel()
    },
  },
  methods: {
    updateLocalValues(val) {
      if (!val) {
        this.hours = 0
        this.minutes = 0
        return
      }
      
      const duration = moment.duration(val)
      const h = Math.floor(duration.asHours())
      const m = duration.minutes()
      
      // Only update if different to avoid infinite loops
      if (this.hours !== h) this.hours = h
      if (this.minutes !== m) this.minutes = m
    },
    updateModel() {
      const h = parseInt(this.hours) || 0
      const m = parseInt(this.minutes) || 0
      
      if (h === 0 && m === 0) {
        if (this.context.model !== '') {
          this.context.model = ''
        }
        return
      }

      const duration = moment.duration({ hours: h, minutes: m })
      const iso = duration.toISOString()
      
      if (this.context.model !== iso) {
        this.context.model = iso
      }
    },
    handleBlur() {
      this.context.blurHandler()
    },
  },
}
</script>

<style lang="scss" scoped>
.hour-minute-input {
  display: flex;
  gap: 8px;
  
  :deep(.formulate-input) {
    margin-bottom: 0 !important;
  }

  :deep(.formulate-input-wrapper) {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  :deep(.formulate-input-element) {
    display: flex;
    width: 100%;
  }
}
</style>
